import config from '../env.json'

export const isValid = (inputString:string)=>{
    let regex = new RegExp(config.REACT_APP_CONTACT_NAME_REGEX)
    let pattern = regex;

    let result = pattern.test(inputString);    

    return result;
}